const LEAVES = [
  [50, 14, '#6fae3c'], [38, 17, '#9bc83f'], [62, 17, '#4f9a35'], [28, 24, '#c8d94a'],
  [72, 24, '#8dbf3e'], [44, 24, '#3f8a2f'], [56, 25, '#b5d046'], [20, 33, '#5ea638'],
  [80, 33, '#a6cc44'], [34, 32, '#e0d65a'], [66, 32, '#5a9e36'], [50, 33, '#8dbf3e'],
  [26, 42, '#9bc83f'], [74, 42, '#3f8a2f'], [40, 40, '#6fae3c'], [60, 40, '#c8d94a'],
  [16, 44, '#b5d046'], [84, 44, '#6fae3c'],
];

export default function Logo({ size = 96 }) {
  return (
    <svg
      viewBox="0 0 100 92"
      width={size}
      height={size * 0.92}
      role="img"
      aria-label="Family Tree Maker Help Center logo"
    >
      {LEAVES.map(([cx, cy, fill]) => (
        <ellipse key={`${cx}-${cy}`} cx={cx} cy={cy} rx="4.6" ry="3.2" fill={fill} />
      ))}
      <path
        d="M47 86c1-10 1-20-1-30-4-4-10-6-15-11 6 3 11 4 15 7 0-5-2-9-5-13 4 3 6 7 7 11 1-4 3-8 6-11-2 4-3 8-3 12 4-3 9-5 15-7-5 4-10 7-14 11-1 11-1 21 0 31z"
        fill="#7a3f1d"
      />
      <path
        d="M14 64c6 6 16 9 24 10 4 1 7 3 9 6-9-1-18-3-26-8-4-2-7-5-7-8zM86 64c-6 6-16 9-24 10-4 1-7 3-9 6 9-1 18-3 26-8 4-2 7-5 7-8z"
        fill="#9a5227"
      />
    </svg>
  );
}
